<!-- footer.component.html -->
<footer class="footer">
    <div class="footer-container">
      <a
        href="https://www.perse.io/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy
      </a>
      <span class="separator">|</span>
      <a
        href="https://energyhelp.perse.io/termsandconditions"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms and Conditions
      </a>
    </div>
  <div class="d-flex justify-content-center align-items-center">
      Share your feedback with us by emailing &nbsp;
      <a href="mailto:business&#64;perse.energy?subject=Feedback%20mail" class="link-3">business&#64;perse.energy</a>
  </div>
  </footer>
  